export default "__VITE_ASSET__c5ab61b3__"